import * as types from './actionTypes';  
import statsFollowerListApi from '../api/statsFollowerListApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchStatsFollowerList(ext_id) {

  return {
    type: types.DO_FETCH_STATS_FOLLOWER_LIST, 
    ext_id
  };
}

export function doFetchStatsFollowerListRes(data) {  
  return {
    type: types.DO_FETCH_STATS_FOLLOWER_LIST_RES, 
    data
  };
}

export function getStatsFollowerList(ext_id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      statsFollowerListApi.doFetchStatsFollowerList(ext_id).then(data => {
        dispatch(doFetchStatsFollowerListRes(data));
        dispatch(doFetchStatsFollowerListRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}